<template>
  <div class="product">
    <el-row :gutter="24" style="margin:0;">
      <el-col :span="16" :offset="4"  >
        <div class="product-head" ref='outer1'>
         <div class="product-head-img">
          <img src="../assets/img/2.2.png" alt="">
         </div>
         <div class="product-head-text">
          <b> <img src="../assets/img/title-red.png" alt="">天基系统产品 · 天基测运控服务</b>
           <p>
            昆仑星座是我国第一个中轨道（MEO）中继卫星系统，首期发射0°倾角轨道面3颗卫星，形成基
本服务能力；二期再部署2个90°轨道面中继卫星，形成对低轨道空间的2-4重覆盖；未来根据用户需求陆续补充发射后续多组卫星，12个轨道面共36颗卫星的星座。能够为各类运载器、航天器、
航空器、浮空器以及陆海用户提供测控数传服务。
           </p>
           <p class="product-head-text-more"> <b @click="imgClick(1)">联系我们</b> <img src="../assets/img/right.png" alt="">        </p>
         </div>
        </div>

        <div class="product-head" ref='outer2'>
         <div class="product-head-text product-headr-text">
          <b> <img src="../assets/img/title-red.png" alt="">地基系统产品 · 地基测运控服务</b>
           <p>
            建成分布于全国的地基测控系统，为商业卫星提供跟踪、遥测、遥控、数据传输和运行控制服
务。S/X双频卫星地面站数据接收最高速率达双路1.2Gbps，为数百颗卫星提供了高质量测控与数传
业务，任务成功率超过99.6%。           </p>

           <p class="product-head-text-more"> <b @click="imgClick(1)">联系我们</b><img src="../assets/img/right.png" alt=""> <b @click="imgClick(0)">查看更多</b><img src="../assets/img/right.png" alt="">    </p>
         </div>
         <div class="product-head-img product-headr-img">
          <img src="../assets/img/2.3.png" alt="">
         </div>
        </div>

        <div class="product-head" ref='outer3'>
         <div class="product-head-img">
          <img src="../assets/img/2.5.png" alt="">
         </div>
         <div class="product-head-text">
          <b> <img src="../assets/img/title-red.png" alt="">软件研发</b>
           <p>
            龙行系统是公司自主开发的一款天基与地基一体、测控与运控一体、测控与数传一体、仿真与任务一体、自动化和智能化一体的大型航天综合服务平台软件，涵盖星座运营管理、站网运维管理、任务规划调度、故障自动诊断、卫星健康管理、任务监控显示、数据处理分发、空间安全分析、业务操作支撑等功能，能够为其他用户提供相关软件研发任务。          </p>
           <p class="product-head-text-more"> <b @click="imgClick(1)">联系我们</b> <img src="../assets/img/right.png" alt=""> <b @click="imgClick(4)">查看更多</b><img src="../assets/img/right.png" alt=""></p>
         </div>
        </div>

        <div class="product-head" ref='outer4'>
         <div class="product-head-text product-headr-text">
          <b> <img src="../assets/img/title-red.png" alt="">航天技术服务</b>
           <p>
            联合相关院所等国内优质合作伙伴，深入开展领域、行业区域融合应用遥感探测技术研究开发与建设，掌握遥感星座设总体设计能力、遥感数据处理技术，具备农作物监测城市管理等多款多类型遥感应用产品的丰富经验，可为农业水利、铁路、环境、应急、海洋、大气等提供解决方案，促进我国卫星应用由项目驱动向应用服务的转变。           </p>
           <p class="product-head-text-more"> <b @click='imgClick(1)'>联系我们</b> <img src="../assets/img/right.png" alt=""></p>
         </div>
         <div class="product-head-img product-headr-img">
          <img src="../assets/img/2.4.png" alt="">
         </div>
        </div>


        <div class="product-head" ref='outer5'>
         <div class="product-head-img">
          <img src="../assets/img/jy.jpeg" alt="">
         </div>
         <div class="product-head-text">
          <b> <img src="../assets/img/title-red.png" alt="">航天教育科普</b>
           <p>
            航天科普教育板块专为孩子们打造，旨在播撒探索宇宙的种子，开启航天领域的无限遐想。我们提供一系列寓教于乐的航天卫星知识课程，结合虚拟现实、动手实验和互动游戏，让孩子们在趣味中学习，激发他们对航天科技的好奇心和探索欲。我们专业教育团队，拥有深厚的航天背景，致力于将前沿的航天知识转化为生动有趣的教学内容。从卫星通信到深空探测，从火箭发射到空间站生活，每一堂课都是通往星辰大海的奇妙旅程。           </p>
           <p class="product-head-text-more"> <b @click="imgClick(1)">联系我们</b> <img src="../assets/img/right.png" alt=""></p>
         </div>
        </div>






      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "product",
  data () {
    return {

    };
  },
  watch: {
    $route(to, from) {
        if (to,from) {
          this.setheight()
        }
      },
    },
  methods:{
    imgClick(num){
      if(num!=1){
        this.$router.push({path:'/productDetail',query:{id:num}})

      }else{
        this.$router.push({path:'/contact',query:{id:num}})

      }
  },
  setheight(){
    var element=0
    if(this.$route.query.id==1){
       element = this.$refs.outer1;
    }else if(this.$route.query.id==2){
       element = this.$refs.outer2;
    }else if(this.$route.query.id==3){
       element = this.$refs.outer3;
    }else if(this.$route.query.id==4){
       element = this.$refs.outer4;
    }else if(this.$route.query.id==5){
       element = this.$refs.outer5;
    }
      if (element) {
        setTimeout(() => {
          const rect = element.getBoundingClientRect();
        const distanceToTop = rect.top + window.scrollY; // 计算距离顶部的距离
        this.$bus.$emit("clearKeyword",distanceToTop);
        }, 500);
      }
  },
  },

  mounted () {
    this.setheight()

    },
  components: {

  }
};
</script>
<style lang="scss" scoped>
.product {
  .product-head{
    display: flex;
    position: relative;
    margin-top:100px;
    margin-bottom:50px;
  }
  .product-head-img{
    width:50%;
    img{
      width:95%;
      height:100%;
      z-index:2;
      position: relative;
      border-radius: 50px 0 50px 0;
    }
  }
  .product-head-text{
      width:50%;
      b{
        font-size:24px;
        color:#353535;

      }
      p{
        margin-right:50px;
        font-size:17px;
        color:#949494;
        margin-top:10px;
      }
      .product-head-text-more{
        position: absolute;
        width:100%;
        background: #f56766;
        height:40px;
        bottom:0;
        margin:0;
        left:0;
        z-index:1;
        border-radius: 0 0 40px 0 ;
        text-align: right;
       b{
        cursor: pointer;
        margin-right:15px;
        color:white;
        font-size:16px;
        line-height: 40px;
       }
       img{
        cursor: pointer;
        width:20px;
        margin-right:40px;
        vertical-align: middle;
       }

      }

  }
  .product-headr-text{
    b{
      margin-left:0;
      margin-right:50px;
    }
    p{
      margin-left:0px;
      margin-right:50px;
    }
    .product-head-text-more{
      text-align: left;
      b{
        margin-left:40px;
      }
     border-radius: 0 0 0 40px;
    }
  }
  .product-headr-img{
    text-align: right;
    img{
      border-radius: 0 50px 0 50px;
    }
  }
}
</style>
<style>
 .is-finish{
  color:#C0C4CC !important;
  border-color:#C0C4CC !important;
}

</style>
